/*[2/24/22, PC_DP_08, Priyanka D]*/
import React, { Component } from 'react';
import * as DefaultPutAwayAction from '../actions/DefaultPutAwayAction';
import DefaultPutAwayStore from '../stores/DefaultPutAwayStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import ReactPaginate from 'react-paginate';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next'
import * as MenuAction from '../actions/MenuAction';
import swal from 'sweetalert';
let currentPagePath;

class DefaultPutAwayComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            /*[2/24/22, PC_DP_15, Priyanka D]*/
            Options: "",
            BuDDName: "",
            BuDDVal: "",
            /*[2/24/22, PC_DP_25, Priyanka D]*/
            Type: "",
            Area: "",
            AIS: "",
            Row: "",
            SHF: "",
            BIN: "",
            AISDD: "",
            ROWDD: "",
            SHFDD: "",
            BINDD: "",
            BULOC: "",
            lblerr: "",
            Update: false,
            AddNewClick: false,
            isFavorited: false,
            //[9/20/22, CR - 2676 - To hide and show the grid, Dhevanesam R]
            //[Bug 5129 PC_5129_01 - Nandhini L]
            ItemIDCheck: true,
            ItemId: ""
        }
    }
    componentDidMount() {
        /*[2/24/22, PC_DP_10, Priyanka D]*/
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        this.PageLoad();
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        DefaultPutAwayAction.getCurrentFavPage(getFavPageBO);
        /*[2/24/22, PC_DP_14, Priyanka D]*/
        DefaultPutAwayStore.on('PageLoadResponse', this.BindBU);
        /*[2/24/22, PC_DP_24, Priyanka D]*/
        DefaultPutAwayStore.on('SearchResponse', this.BindGrid);
        /*[2/25/22, PC_DP_32, Priyanka D]*/
        DefaultPutAwayStore.on('AddNewResponse', this.NewLoc);
        /*[2/25/22, PC_DP_46, Priyanka D]*/
        DefaultPutAwayStore.on('SaveResponse', this.SaveResponse);
        DefaultPutAwayStore.on('favpage', this.loadFavPageResponse.bind(this));
        DefaultPutAwayStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
    }
    /*[2/24/22, PC_DP_11, Priyanka D]*/
    PageLoad = () => {
        let PageloadBO = {
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BusUnit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
        }
        DefaultPutAwayAction.Pageload(PageloadBO);
    }
    /*[2/25/22, PC_DP_32, Priyanka D]*/
    NewLoc = () => {
        ////debugger
        let LocData = JSON.parse(DefaultPutAwayStore.AddNewResponse);
        if (LocData.BULocations != undefined) {
            if (LocData.BULocations.length == 0) {
                // 'WW-940 When doing a default put-away for W01901594, pop-up indicating successful save appears but update not reflected when going back to the page - Deepthi
                $('#NewLocPopup').modal('hide')
                this.setState({ ItemIDCheck: true });
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Locations are not available for this crib to default currently"
                });
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
            }
            else {
                this.setState({
                    Area: "",
                    AIS: "",
                    Row: "",
                    SHF: "",
                    BIN: "",
                })
                $('#StatusMsg').addClass('hide');
                $('#table').removeClass('hide');
                $('#AddNew').addClass('hide');
                $('#NewLocPopup').modal('hide')
                // this.BuildDD(LocData);
                //Regresson bug 4143- Surya  --[ 11-13-2024 ]
                let locations = LocData.BULocations
                if ((locations != undefined && locations != null)) {
                    let AreaDD = [];
                    locations.map((item, index) => {
                        let obj = {
                            value: item.STORAGE_AREA,
                            label: item.STORAGE_AREA
                        }
                        AreaDD.push(obj);
                    })
                    AreaDD = AreaDD.filter((ele, ind) => ind === AreaDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                    this.setState({ AreaDD: AreaDD, BULOC: locations })
                }

            }
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');


    }
    /*[2/24/22, PC_DP_16, Priyanka D]*/
    BindBU = () => {
        ////debugger;
        $('#table').addClass('hide');
        let PageLoadBU = JSON.parse(DefaultPutAwayStore.PageLoadResponse);
        let BuArraydata = PageLoadBU.Table;
        let locBU = []
        BuArraydata.map((val, index) => {
            let localArray = {
                value: val.BUSINESS_UNIT_IN,
                label: val.DESCR, //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
            }
            locBU.push(localArray)
        });
        console.log("locBU[0]", locBU[0])
        this.setState({ BuDDName: locBU[0] });
        this.BusUnitDD(BuArraydata);
    }
    /*[2/24/22, PC_DP_17, Priyanka D]*/
    BusUnitDD = (BuArraydata) => {
        let BusUnitDDValue = [];
        if (BuArraydata.length > 0) {
            BuArraydata.map((val, index) => {
                let localArray = {
                    value: val.BUSINESS_UNIT_IN,
                    label: val.DESCR,//WBW-15_PC_03 to display the crib name (2/18/2022) -Aparna
                }
                BusUnitDDValue.push(localArray)
            });
            this.setState({ Options: BusUnitDDValue });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }

    }
    /*[2/24/22, PC_DP_19, Priyanka D]*/
    handleBUDDChange = (e) => {
        this.setState({ BuDDName: e, BuDDVal: e.value, ItemIDCheck: true })
    }
    //Bug 5129 PC_5129_02 - Nandhini L
    handleItem = (e) => {
        $('#StatusMsg').addClass('hide');
        this.setState({ ItemId: e.target.value, ItemIDCheck: true })
    }
    /*[2/24/22, PC_DP_21, Priyanka D]*/
    SeachClick = (e) => {
        ////debugger
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //Bug - 2568 - UI issue in default putaway location - Dhamotharan P
        //debugger;
        let ItemID = $('#ItemID').val().trim();
        if (ItemID == "") {
            {/* swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter Item ID"
            }); */}

            // alert("Please enter Item ID");
            //[9/20/22, CR - 2676 - To hide and show the grid, Dhevanesam R]
            this.setState({ ItemIDCheck: true, lblerr: "Please enter Item ID" })
            $('#StatusMsg').removeClass('hide');

            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            return;
        }
        else {
            let SearchBO = {
                ItemID: ItemID,
                SelectedBU: this.state.BuDDName.value,
                Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BusUnit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            }
            DefaultPutAwayAction.Search(SearchBO)
            //[9/20/22, CR - 2676 - To hide and show the grid, Dhevanesam R]
            this.setState({ ItemIDCheck: false })
            $('#table').removeClass('hide');
        }
    }
    /*[2/24/22, PC_DP_26, Priyanka D]*/
    BindGrid = () => {
        ////debugger
        let SearchData = JSON.parse(DefaultPutAwayStore.SearchResponse);
        if (SearchData.ErrorMessage[0].lblerror != null && SearchData.ErrorMessage[0].lblerror != "" && SearchData.ErrorMessage[0].lblerror != " " && SearchData.ErrorMessage[0].lblerror != undefined) {
            //Regresson bug 4143- Surya [ 11/13/2024 ]
            if (SearchData.ErrorMessage[0].lblerror.toLowerCase() === "default putaway location does not exist for this item. do you want to add new location?".toLowerCase()) {
                $('#NewLocPopup').modal('show')
                $('#StatusMsg').addClass('hide');
                //[9/20/22, CR - 2676 - To hide and show the grid, Dhevanesam R]
                this.setState({ ItemIDCheck: true })

            }
            else if (SearchData.ErrorMessage[0].lblerror == "Item ID is invalid") {
                let message = SearchData.ErrorMessage[0].lblerror;

                {/* swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: message
                }); */}
                //[9/20/22, CR - 2676 - To hide and show the grid, Dhevanesam R]
                this.setState({ ItemIDCheck: true, lblerr: message })
                $('#StatusMsg').removeClass('hide');
            }

            $('#table').addClass('hide');
            //  $('#AddNew').removeClass('hide');

        } else {
            $('#StatusMsg').addClass('hide');

            this.GridDD(SearchData);
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }
    /*[2/24/22, PC_DP_27, Priyanka D]*/
    GridDD = (SearchData) => {
        ////debugger
        let GridData = SearchData.ItemsLocation;
        let Area = []
        let localAreaArray = {
            value: GridData[0].STORAGE_AREA,
            label: GridData[0].STORAGE_AREA,
        }
        Area.push(localAreaArray)
        let AIS = []
        let localAISArray = {
            value: GridData[0].STOR_LEVEL_1,
            label: GridData[0].STOR_LEVEL_1,
        }
        AIS.push(localAISArray)
        let ROW = []
        let localROWArray = {
            value: GridData[0].STOR_LEVEL_2,
            label: GridData[0].STOR_LEVEL_2,
        }
        ROW.push(localROWArray)
        let SHF = []
        let localSHFArray = {
            value: GridData[0].STOR_LEVEL_3,
            label: GridData[0].STOR_LEVEL_3,
        }
        SHF.push(localSHFArray)
        let BIN = []
        let localBINArray = {
            value: GridData[0].STOR_LEVEL_4,
            label: GridData[0].STOR_LEVEL_4,
        }
        BIN.push(localBINArray)
        //[9/20/22, CR - 2676 - To hide and show the grid, Dhevanesam R]
        this.setState({ Type: GridData[0].DEF_LOC_TYPE, Area: Area[0], AIS: AIS[0], Row: ROW[0], SHF: SHF[0], BIN: BIN[0], ItemIDCheck: false })
        this.BuildDD(SearchData);
    }
    /*[2/28/22, PC_DP_27, Priyanka D]*/
    BuildDD = (SearchData) => {
        let locations = SearchData.BULocations
        let AreaDD = [];
        locations.map((item, index) => {
            let obj = {
                value: item.STORAGE_AREA,
                label: item.STORAGE_AREA
            }
            AreaDD.push(obj);
        })
        AreaDD = AreaDD.filter((ele, ind) => ind === AreaDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))

        let AISDD = [];
        locations.map((item, index) => {
            if (SearchData.ItemsLocation != undefined) {
                if (item.STORAGE_AREA == SearchData.ItemsLocation[0].STORAGE_AREA) {
                    let obj = {
                        value: item.STOR_LEVEL_1,
                        label: item.STOR_LEVEL_1
                    }
                    AISDD.push(obj);
                }
            }
            else {
                let obj = {
                    value: item.STOR_LEVEL_1,
                    label: item.STOR_LEVEL_1
                }
                AISDD.push(obj);
            }
        })
        AISDD = AISDD.filter((ele, ind) => ind === AISDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        let ROWDD = [];
        locations.map((item, index) => {
            if (SearchData.ItemsLocation != undefined) {
                if (item.STORAGE_AREA == SearchData.ItemsLocation[0].STORAGE_AREA && item.STOR_LEVEL_1 == SearchData.ItemsLocation[0].STOR_LEVEL_1) {
                    let obj = {
                        value: item.STOR_LEVEL_2,
                        label: item.STOR_LEVEL_2
                    }
                    ROWDD.push(obj);
                }
            } else {
                let obj = {
                    value: item.STOR_LEVEL_2,
                    label: item.STOR_LEVEL_2
                }
                ROWDD.push(obj)
            }
        })
        ROWDD = ROWDD.filter((ele, ind) => ind === ROWDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))

        let SHFDD = [];
        locations.map((item, index) => {
            if (SearchData.ItemsLocation != undefined) {
                if (item.STORAGE_AREA == SearchData.ItemsLocation[0].STORAGE_AREA && item.STOR_LEVEL_1 == SearchData.ItemsLocation[0].STOR_LEVEL_1 && item.STOR_LEVEL_2 == SearchData.ItemsLocation[0].STOR_LEVEL_2) {
                    let obj = {
                        value: item.STOR_LEVEL_3,
                        label: item.STOR_LEVEL_3
                    }
                    SHFDD.push(obj);
                }
            }
            else {
                let obj = {
                    value: item.STOR_LEVEL_3,
                    label: item.STOR_LEVEL_3
                }
                SHFDD.push(obj);
            }
        })
        SHFDD = SHFDD.filter((ele, ind) => ind === SHFDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))

        let BINDD = [];
        locations.map((item, index) => {
            if (SearchData.ItemsLocation != undefined) {
                if (item.STORAGE_AREA == SearchData.ItemsLocation[0].STORAGE_AREA && item.STOR_LEVEL_1 == SearchData.ItemsLocation[0].STOR_LEVEL_1 && item.STOR_LEVEL_2 == SearchData.ItemsLocation[0].STOR_LEVEL_2 && item.STOR_LEVEL_3 == SearchData.ItemsLocation[0].STOR_LEVEL_3) {
                    let obj = {
                        value: item.STOR_LEVEL_4,
                        label: item.STOR_LEVEL_4
                    }
                    BINDD.push(obj);
                }
            } else {
                let obj = {
                    value: item.STOR_LEVEL_4,
                    label: item.STOR_LEVEL_4
                }
                BINDD.push(obj);
            }
        })
        BINDD = BINDD.filter((ele, ind) => ind === BINDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        this.setState({ AreaDD: AreaDD, AISDD: AISDD, ROWDD: ROWDD, SHFDD: SHFDD, BINDD: BINDD, BULOC: locations })
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /*[2/25/22, PC_DP_35, Priyanka D]*/
    AreaOnChange = (e) => {
        this.setState({ Area: e })
        let ASIArr = []
        this.state.BULOC.map((item, index) => {
            if (item.STORAGE_AREA == e.label) {
                let obj = {
                    value: item.STOR_LEVEL_1,
                    label: item.STOR_LEVEL_1
                }
                ASIArr.push(obj);
            }
            ASIArr = ASIArr.filter((ele, ind) => ind === ASIArr.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
            this.setState({ AISDD: ASIArr, ROWDD: [], SHFDD: [], BINDD: [], AIS: [], Row: [], SHF: [], BIN: [], Update: true });
        });
    }
    /*[2/25/22, PC_DP_37, Priyanka D]*/
    ASIOnChange = (e) => {
        ////debugger
        this.setState({ AIS: e })
        let ROWArr = []
        this.state.BULOC.map((item, index) => {
            if (item.STORAGE_AREA == this.state.Area.label && item.STOR_LEVEL_1 == e.label) {
                let obj = {
                    value: item.STOR_LEVEL_2,
                    label: item.STOR_LEVEL_2
                }
                ROWArr.push(obj);
            }
            ROWArr = ROWArr.filter((ele, ind) => ind === ROWArr.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
            this.setState({ ROWDD: ROWArr, SHFDD: [], BINDD: [], Row: [], SHF: [], BIN: [], Update: true });
        });
    }
    /*[2/25/22, PC_DP_39, Priyanka D]*/
    ROWOnChange = (e) => {
        this.setState({ Row: e })
        let SHFArr = []
        this.state.BULOC.map((item, index) => {
            if (item.STORAGE_AREA == this.state.Area.label && item.STOR_LEVEL_1 == this.state.AIS.label && item.STOR_LEVEL_2 == e.label) {
                let obj = {
                    value: item.STOR_LEVEL_3,
                    label: item.STOR_LEVEL_3
                }
                SHFArr.push(obj);
            }
            SHFArr = SHFArr.filter((ele, ind) => ind === SHFArr.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
            this.setState({ SHFDD: SHFArr, BINDD: [], SHF: [], BIN: [], Update: true });
        });
    }
    /*[2/25/22, PC_DP_40, Priyanka D]*/
    SHFOnChange = (e) => {
        this.setState({ SHF: e })
        let BINArr = []
        this.state.BULOC.map((item, index) => {
            if (item.STORAGE_AREA == this.state.Area.label && item.STOR_LEVEL_1 == this.state.AIS.label && item.STOR_LEVEL_2 == this.state.Row.label && item.STOR_LEVEL_3 == e.label) {
                let obj = {
                    value: item.STOR_LEVEL_4,
                    label: item.STOR_LEVEL_4
                }
                BINArr.push(obj);
            }
            BINArr = BINArr.filter((ele, ind) => ind === BINArr.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
            this.setState({ BINDD: BINArr, BIN: [], Update: true });
        });
    }
    /*[2/25/22, PC_DP_42, Priyanka D]*/
    BinOnChange = (e) => {
        this.setState({ BIN: e })
    }
    /*[2/25/22, PC_DP_29, Priyanka D]*/
    AddNewLoc = () => {
        let AddNewBO = {
            SelectedBU: this.state.BuDDName.value,
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BusUnit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
        }
        //[9/20/22, CR - 2676 - To hide and show the grid, Dhevanesam R]

        // [11/14/2024,  Regression BUG  -  4143  , Surya K ]
        this.setState({ AddNewClick: true, ItemIDCheck: false, AreaDD: "", AISDD: "", ROWDD: "", SHFDD: "", BINDD: "" });

        DefaultPutAwayAction.AddNewLoc(AddNewBO);
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }
    /*[2/25/22, PC_DP_43, Priyanka D]*/
    SaveClick = () => {
        let Update = true;
        if (this.state.Area == "" || this.state.AIS == "" || this.state.Row == "" || this.state.SHF == "" || this.state.BIN == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select all the fields!"
            });
            //  alert("Please select all the fields!");
            return;
        }
        if (this.state.AddNewClick == true) {
            Update = false
        } else if (this.state.Update) {
            Update = true
        }
        let SaveBO = {

            Area: this.state.Area.value,
            AIS: this.state.AIS.value,
            Row: this.state.Row.value,
            SHF: this.state.SHF.value,
            BIN: this.state.BIN.value,
            ItemID: $('#ItemID').val(),
            Update: Update,
            SelectedBU: this.state.BuDDName.value,
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BusUnit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
        }
        DefaultPutAwayAction.Save(SaveBO)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }
    SaveResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let SaveData = JSON.parse(DefaultPutAwayStore.SaveResponse);
        if (SaveData.ErrorMessage[0].lblerror != null && SaveData.ErrorMessage[0].lblerror != "" && SaveData.ErrorMessage[0].lblerror != " " && SaveData.ErrorMessage[0].lblerror != undefined) {
            let message = SaveData.ErrorMessage[0].lblerror;
            {/*swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: message
            }); */}
            $('#StatusMsg').addClass('hide');
            $('#submitResponsePopupId').modal('show');
            this.setState({ AddNewClick: false });
        }
    }

    submitResponseOk = () => {
        $('#submitResponsePopupId').modal('hide');
    }

    //To handle the favorite page
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Default PutAway Locations",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            DefaultPutAwayAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            DefaultPutAwayAction.deleteFavPage(deleteFavPageBO)
        }
    };
    loadFavPageResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let favPageResponse = JSON.parse(DefaultPutAwayStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (DefaultPutAwayStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(DefaultPutAwayStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(DefaultPutAwayStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        // this.refreshMenu();
    };
    // Bug 5129 PC_5129_03 - Nandhini L
    AnykeyPress = (e) => {
        if (e.keyCode == 13) {
            this.SeachClick(e);
        }
    };
    // Bug 5129 PC_5129_04 - Nandhini L
    ClearItemId = () => {
        $('#StatusMsg').addClass('hide');
        this.setState({ ItemId: "", ItemIDCheck: true })
    }

    render() {
        return (
            <div class="container-fluid content-section">
                <div class="row">
                    <div class="col-md-12 page-heading mb-2">
                        <h5 class="page-title">Default Putaway Locations</h5>
                        <div className="fav-item-maintenance-icon mt-1">
                            <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                            <label htmlFor="checkbox-OrdStatus">
                                <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                    <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                        <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                        <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                        <g className="grp7" opacity={0} transform="translate(7 6)">
                                            <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                            <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                        </g>
                                        <g className="grp6" opacity={0} transform="translate(0 28)">
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                        </g>
                                        <g className="grp3" opacity={0} transform="translate(52 28)">
                                            <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                            <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                        </g>
                                        <g className="grp2" opacity={0} transform="translate(44 6)">
                                            <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp5" opacity={0} transform="translate(14 50)">
                                            <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp4" opacity={0} transform="translate(35 50)">
                                            <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp1" opacity={0} transform="translate(24)">
                                            <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                            <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                        </g>
                                    </g>
                                </svg>
                            </label>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-12 my-3">
                                <div class="row">
                                    <div class="col-md-4 col-lg-3">
                                        <div className="row">
                                            <label class="catalog-label col-md-3 col-lg-3 px-0 w-100 mt-2" for="BusinessUnit">Crib ID</label>
                                            {/*select class="form-control col-md-7 col-lg-8" id="BusinessUnit">
                                                <option>Select</option>
                                                <option>Option</option>
                                            </select>*/}
                                            <span style={{ "fontSize": "14px" }} className="col-md-9 col-lg-9"><Select
                                                id="BusinessUnit"
                                                name="Area"
                                                options={this.state.Options}
                                                value={this.state.BuDDName} /*[2/24/22, PC_DP_15, Priyanka D]*/
                                                onChange={(e) => this.handleBUDDChange(e)}
                                            /></span>
                                        </div>

                                    </div>
                                    <div class="col-md-4 col-lg-3">
                                        <div className="row">
                                            <label class="catalog-label col-md-3 col-lg-3 w-100 mt-2" for="ItemID"  >Item ID</label>
                                            <input type="text" class="form-control col-md-9 col-lg-9 " onChange={(e) => this.handleItem(e)} id="ItemID" maxLength="18" onKeyDown={this.AnykeyPress} value={this.state.ItemId} />
                                            {/*[Bug 5129 PC_5129_06 - Nandhini L ]*/}
                                            {this.state.ItemId != undefined && this.state.ItemId != null && this.state.ItemId != "" && this.state.ItemId != " " ?
                                                <span class="search-cancel-header cursor-pointer position-absolute" style={{ right: "22px", top: "12px" }} onClick={() => this.ClearItemId()} > </span> : null
                                            }
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-3">
                                        {/*[2/24/22, PC_DP_20, Priyanka D]*/}
                                        <button class="btn btn-primary custom-btn-primary primary-btn  ml-3" onClick={e => this.SeachClick(e)}>Search</button>
                                        {/*{(this.state.lblerr == "Default Putaway Location does not exist for this Item. Do you want to add new location?") ?
                                                    <button class="btn btn-primary custom-btn-primary primary-btn  ml-2" id="AddNew" onClick={e => this.AddNewLoc()}>Add New Location</button> :
                                                    null}*/}
                                    </div>
                                </div>

                                <div class="w-100">
                                    <p class="priority-alert" id="StatusMsg" style={{ "marginLeft": "460px" }}>{this.state.lblerr}</p>
                                </div>
                            </div>

                            {/*Default Putaway Location starts here*/}
                            {/*[9/20/22, CR - 2676 - To hide and show the grid, Dhevanesam R]*/}
                            {this.state.ItemIDCheck == false ?
                                <div class="col-md-12 float-left mb-4">
                                    <div class=" table-customstyle-whitespace mt-3">
                                        <table class="table ZEUS_Grid FOM-grid mobileflex-grid" id="table">
                                            <thead>
                                                <tr>

                                                    <th>Type</th>
                                                    <th>Area</th>
                                                    <th>Aisle</th>
                                                    <th>Row</th>
                                                    <th>Shelf</th>
                                                    <th>Bin</th>
                                                    <th class="text-center">Action</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>

                                                    <td data-label="Type">Owned</td>
                                                    <td data-label="Area">
                                                        <Select class="form-control"
                                                            id="AreaDD"
                                                            name="Area"
                                                            options={this.state.AreaDD}
                                                            classNamePrefix="react-select"
                                                            value={this.state.Area} /*[2/24/22, PC_DP_15, Priyanka D]*/
                                                            onChange={(e) => this.AreaOnChange(e)}/*[2/25/22, PC_DP_34, Priyanka D]*/
                                                        />
                                                    </td>
                                                    <td data-label="Aisle">
                                                        <Select
                                                            id="AreaDD"
                                                            name="Area"
                                                            options={this.state.AISDD}
                                                            classNamePrefix="react-select"
                                                            value={this.state.AIS} /*[2/24/22, PC_DP_15, Priyanka D]*/
                                                            onChange={(e) => this.ASIOnChange(e)}/*[2/25/22, PC_DP_36, Priyanka D]*/
                                                        />

                                                    </td>
                                                    <td data-label="Row">
                                                        <Select class="form-control"
                                                            id="AreaDD"
                                                            name="Area"
                                                            classNamePrefix="react-select"
                                                            options={this.state.ROWDD}
                                                            value={this.state.Row} /*[2/24/22, PC_DP_15, Priyanka D]*/
                                                            onChange={(e) => this.ROWOnChange(e)}/*[2/25/22, PC_DP_38, Priyanka D]*/
                                                        />
                                                    </td>
                                                    <td data-label="Shelf">
                                                        <Select class="form-control"
                                                            id="AreaDD"
                                                            name="Area"
                                                            style={{ "resize": "none" }}
                                                            options={this.state.SHFDD}
                                                            classNamePrefix="react-select"
                                                            value={this.state.SHF} /*[2/24/22, PC_DP_15, Priyanka D]*/
                                                            onChange={(e) => this.SHFOnChange(e)}/*[2/25/22, PC_DP_40, Priyanka D]*/
                                                        />
                                                    </td>
                                                    <td data-label="Bin"> <Select class="form-control"
                                                        id="AreaDD"
                                                        name="Area"
                                                        options={this.state.BINDD}
                                                        classNamePrefix="react-select"
                                                        value={this.state.BIN} /*[2/24/22, PC_DP_15, Priyanka D]*/
                                                        onChange={(e) => this.BinOnChange(e)}
                                                    />
                                                    </td>
                                                    <td class="text-center" data-label="Action">
                                                        {/*[2/25/22, PC_DP_42, Priyanka D]*/}
                                                        <a><img title="Save" src="images/save-icon.svg" alt="save icon" onClick={(e) => this.SaveClick()} /></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div> : null}
                        </div>
                    </div>
                </div>
                <div className="modal" id="NewLocPopup" data-backdrop="static">
                    <div className="modal-dialog custom-popup modal-dialog-centered" style={{ "maxWidth": "384px" }} data-backdrop="static">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header bg-white border-0">
                                <h2 className="mt-1 fav-item-title">Add new location</h2>
                                <button type="button" className="btn close-btn bg-white" data-dismiss="modal">
                                    X
                                 </button>
                            </div>
                            {/* Modal body */}
                            <div className="col-md-12">
                                <div className="text-center my-4">
                                    <span className="info-label">Default putaway location does not exist for this Item. Do you want to add new location?</span>
                                </div>


                                <div className="text-center mb-4">
                                    <button className="btn btn-secondary custom-btn-custom-btn-secondary secondary-btn px-4 mr-2" data-dismiss="modal">No</button>
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4" onClick={e => this.AddNewLoc()}>Yes</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="modal fade success-customer" id="submitResponsePopupId" tabIndex={-1} role="dialog" data-backdrop="static" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered custom-success-width" role="document">
                        <div className="modal-content py-2">
                            {/*Success Starts here*/}
                            <div className="modal-body pb-2">
                                <div className="row">
                                    <div className="col-12 col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img className="mb-3" src="images/tick.svg" alt="tick" />
                                        <p className="mb-1 font-14 font-regular color-light-black">Default putaway location updated successfully!</p>
                                    </div>
                                </div>
                            </div>
                            {/*Success end here*/}
                            {/*button*/}
                            <div className="modal-footer border-0 d-flex justify-content-center pt-1">
                                <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" onClick={() => { this.submitResponseOk() }}>OK</button>
                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>



            </div>);



    }

}
export default withTranslation()(DefaultPutAwayComponent);